import React from "react";
import { ErrorMessage, Field } from "formik";
import { Editor } from "primereact/editor";
import ExtendedLabel from "../../extendedLabel/extendedLabel";

function EditorComponent(props: any) {
  const { name, label, extendedlabel, isRequired, ...rest } = props;
  return (
    <div className="flex flex-col w-full py-2" id={name.split(".").pop()}>
      <div className="extentedlabel-container ">
        {" "}
        <label htmlFor={name} className={isRequired ? "isRequired" : ""}>
          {" "}
          {label}
        </label>{" "}
        {extendedlabel && <ExtendedLabel text={extendedlabel} />}
        <Field alt={name} name={name} {...rest} as={Editor} />
      </div>
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default EditorComponent;
